export default "__VITE_ASSET__BhJNnfH0__"